import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@coolblue-development/freddy';
import { Mail } from '@coolblue-development/icons';
const OutOfStockButton = ({ ariaLabel, disabled = false, isFullWidth = false, href, label, onClick, rel, variant = 'default', }) => {
    return (_jsx(Button, { "aria-label": ariaLabel, component: href ? 'a' : 'button', disabled: disabled, fullWidth: isFullWidth, href: href, onClick: onClick, rel: href ? rel : undefined, startIcon: _jsx(Mail, {}), type: href ? undefined : 'button', variant: "primary", children: variant === 'default' && label }));
};
export default OutOfStockButton;
//# sourceMappingURL=OutOfStockButton.js.map